const Validacoes = {
    email: (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
    },
    cnpj: (value) => {
        const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;
        return cnpjRegex.test(value);
    },
    cpf: (value) => /^(\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/.test(value),
    rg: (value) => {
        const onlyChars = value.toUpperCase().replace(/[^0-9X]/g, '');
        const allSameDigits = /^(\d)\1+$/.test(onlyChars.replace(/X/g, ''));
        return onlyChars.length >= 5 && onlyChars.length <= 12 && !allSameDigits;
    },
    inscricaoEstadual: (value) => {
        const onlyDigits = value.replace(/\D/g, '');
        const allSameDigits = /^(\d)\1+$/.test(onlyDigits);
        return onlyDigits.length >= 8 && onlyDigits.length <= 12 && !allSameDigits;
    },
    telefone: (value) => {
        const onlyDigits = String(value || "").replace(/\D/g, '');
        const allSameDigits = /^(\d)\1+$/.test(onlyDigits);

        return (onlyDigits.length === 10 || onlyDigits.length === 11) && !allSameDigits;
    },
    url: (value) => {
        const urlRegex = /^https?:\/\/.+/;
        return urlRegex.test(value);
    },
    cep: (value) => {
        const cepRegex = /^\d{5}-\d{3}$/;
        return cepRegex.test(value);
    },
    uf: (value) => {
        const ufRegex = /^[A-Z]{2}$/;
        return ufRegex.test(value);
    },
    cstIcms: (value) => {
        const regex = /^(100|[0-9]{1,2})([.,][0-9]{1,2})?$/;

        if (!regex.test(value)) return false;

        const num = parseFloat(value.replace(",", "."));
        return !isNaN(num) && num >= 0 && num <= 100;
    },
    cstIpi: (value) => {
        const regex = /^([0-9]{1,2})([.,][0-9]{1,2})?$/;

        if (!regex.test(value)) return false;

        const num = parseFloat(value.replace(",", "."));
        return !isNaN(num) && num >= 0 && num <= 99;
    },
    validarCamposObrigatorios: (formData, fields, fieldLabels) => {
        const validationErrors = {};

        fields.forEach(field => {
            const value = formData[field];

            if (Array.isArray(value) && value.length === 0) {
                validationErrors[field] = `Selecione pelo menos uma opção para ${fieldLabels[field] || field}`;
            } else if (typeof value === "string" && !value.trim()) {
                validationErrors[field] = `${fieldLabels[field] || field} é obrigatório`;
            } else if (value == null) {
                validationErrors[field] = `${fieldLabels[field] || field} é obrigatório`;
            }
        });

        return validationErrors;
    }
};

export default Validacoes;
